import $ from "jquery";
import React from "react";

const ToggleMenu = ({ className }) => {
  const toggleMenu = (e) => {
    e.preventDefault();
    const $body = $("body");
    const $html = $("html");

    if (!$body.hasClass("menu-on-top")) {
      $html.toggleClass("hidden-menu-mobile-lock");
      $body.toggleClass("hidden-menu");
      $body.removeClass("minified");
    } else if ($body.hasClass("menu-on-top") && $body.hasClass("mobile-view-activated")) {
      $html.toggleClass("hidden-menu-mobile-lock");
      $body.toggleClass("hidden-menu");
      $body.removeClass("minified");
    }
  };
  return (
    <div id="hide-menu" className={className}>
      <span>
        <a href="#/" onClick={toggleMenu} title="Collapse Menu">
          <i className="fa fa-reorder" />
        </a>
      </span>
    </div>
  );
};

export default ToggleMenu;
